var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__people-24px",
    width: 36.691,
    height: 36.691,
    viewBox: "0 0 36.691 30.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_418",
    fill: "none",
    d: "M0 0h36.691v36.691H0z",
    "data-name": "Path 418"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_419",
    d: "M12.7 18.377c-3.576 0-10.7 1.789-10.7 5.351V26.4h21.4v-2.672c0-3.562-7.121-5.351-10.7-5.351zm-7.123 4.968a14.74 14.74 0 0 1 7.123-1.911 14.74 14.74 0 0 1 7.124 1.911zM12.7 15.7a5.351 5.351 0 1 0-5.351-5.351A5.357 5.357 0 0 0 12.7 15.7zm0-7.644a2.293 2.293 0 1 1-2.293 2.293A2.29 2.29 0 0 1 12.7 8.058zm10.764 10.413a6.41 6.41 0 0 1 3 5.259V26.4h6.115v-2.672c-.003-3.089-5.354-4.847-9.115-5.259zm-1.59-2.769a5.351 5.351 0 0 0 0-10.7 5.267 5.267 0 0 0-2.293.535 8.349 8.349 0 0 1 0 9.631 5.267 5.267 0 0 0 2.293.534z",
    "data-name": "Path 419",
    transform: "translate(1.058 2.644)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientlist);
export default __webpack_public_path__ + "static/media/clientlist.a6c0bcc2.svg";
export { ForwardRef as ReactComponent };